import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-image",
  style: {"fontsize":"1.5rem"}
}, null, -1)
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "p-col" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Drag and drop files to here to upload.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '50vw' },
    maximizable: false,
    position: "middle",
    class: "p-fluid",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialogBox
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FileUpload, {
              name: "image[]",
              customUpload: true,
              onUploader: _ctx.myUploader,
              previewWidth: 150,
              multiple: false,
              accept: _ctx.imageType,
              maxFileSize: 2000000
            }, {
              empty: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onUploader", "accept"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}